module.exports = __webpack_public_path__ + "4b5e9dab3461eeb8251cca2c717e1172.svg";